import { createSelector } from '@reduxjs/toolkit';
import { selectors as dataGridTableSelectors } from '../Modules/dataGridTable';
import { getGlobalDepartments } from 'utils/personnelHelper';
import { getGlobalDepartmentRecords } from 'selectors/globalSelectors';
import { transform as transformList } from 'utils/DataTransform/Clients/ClientList';
import { transform as transformDetails } from 'utils/DataTransform/Clients/ClientDetails';
import { selectors as filtersSelectors } from '../Modules/filters';
import { getLanguageDictionary } from 'reducers/utils';
import { getBusinessClientListTransformed } from '../../BusinessClients/Selectors/businessClientSelectors';

export const getCustomerListTransformed = createSelector(
  dataGridTableSelectors.getGridTableList,
  getGlobalDepartmentRecords,
  (customerList, globalDepartmentRecords) => {
    if (!customerList) {
      return [];
    }
    const globalDepartmentList = getGlobalDepartments(globalDepartmentRecords);
    const list = transformList({
      list: customerList,
      globalDepartmentList,
    });
    return list;
  },
);
export const getCustomerListRaw = createSelector(
  dataGridTableSelectors.getGridTableList,
  customerList => {
    if (!customerList) {
      return [];
    }

    return customerList;
  },
);

export const getTotalRowsCount = createSelector(
  dataGridTableSelectors.getTotalGridRows,
  rowsCount => rowsCount,
);

export const getCustomerDetailsTransformed = createSelector(
  dataGridTableSelectors.getGridRowDetails,
  getLanguageDictionary,
  getBusinessClientListTransformed,
  getGlobalDepartmentRecords,
  (details, dict, businessClients, globalDepartmentRecords) => {
    if (!details) {
      return {};
    }
    // convert it into id and name list array
    const globalDepartmentList = getGlobalDepartments(globalDepartmentRecords);

    return transformDetails({
      data: details,
      languageList: dict,
      businessClientList: businessClients,
      globalDepartmentList: globalDepartmentList,
    });
  },
);

export const getSelectedRowID = createSelector(
  dataGridTableSelectors.getSelectedRowID,
  selectedRowID => selectedRowID,
);

export const getForceRefresh = createSelector(
  dataGridTableSelectors.getForceRefresh,
  forceRefresh => forceRefresh,
);

export const getCustomerFilters = createSelector(
  filtersSelectors.getFilterValues,
  filterValues => {
    return filterValues;
  },
);
